<div class="relative w-full h-full">
    <app-header [isSidebarOpen]="isSidebarOpen" [toggleSidebar]="toggleSidebar.bind(this)"></app-header>
    <app-sidebar [isSidebarOpen]="isSidebarOpen" [toggleSidebar]="toggleSidebar.bind(this)"></app-sidebar>
    <main class="main-content !pt-[60px] !xl:pt-[80px]" [ngClass]="{ 'has-sidebar': isSidebarOpen }">
        <div class="main-inner !px-0 !bg-[#fbfdff]">
            <router-outlet></router-outlet>
        </div>
    </main>
</div>
